/**
 * Scene component extracted from FarmScene
 */

class FarmSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.getBackgroundStyles());
        this.sceneComponent.setBundles(this.listBundles());
    }

    onSceneLoaded() {
        this.map = new WorldMap();
        this.node.screen.addChild(this.map);

        this.controller = new FarmController(this.map);

        this.node.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.DelayTime(5),
            cleverapps.effects.fireAction("location.city.loop"),
            new cc.DelayTime(5)
        )));

        this.controller.onEnter();
    }

    onDestruct() {
        if (this.controller) {
            this.controller.clear();
        }
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView({
            isSmall: false,
            hard: false
        });
        return this.playButton;
    }

    onPlayIntro(f, silent) {
        this.controller.showUp(f, silent);
        return true;
    }

    getBackgroundStyles() {
        return undefined;
    }

    listBundles() {
        const res = ["world_map", "dialogues", "main", "farm_windows"];

        for (let buildingsId = 0; bundles[`metha_top_layer_${buildingsId}`]; buildingsId++) {
            res.push(`metha_top_layer_${buildingsId}`);
        }
        for (let roomsId = 0; bundles[`metha_bottom_layer_${roomsId}`]; roomsId++) {
            res.push(`metha_bottom_layer_${roomsId}`);
        }
        return res;
    }
}

Prefab.registerComponent("FarmSceneComponent", FarmSceneComponent);
